module.exports = __webpack_public_path__ + "img/snow.c87edc9.jpg";